<template>
    <div>
        <div class="media blogItem">
            <blog-avatar :w="64" :h="64" :blog="blog" class="mr-3"/>
            <div class="media-body">
              <h5 class="mt-0">
                <a :href="getBlogUrl(blog)" @click.prevent="openBlog(blog)">{{blog.title}}</a></h5>
                <f-button :blog="blog" />
            </div>
        </div>

    </div>
</template>

<script>

    import BlogAvatar from '../ui/BlogAvatar.vue';
    import fButton from '../ui/buttons/FollowButton.vue';

    export default {
        name: 'BlogListItemSmall',
        props: ['blog'],
        data() {
            return {}
        },
        created() {
        },
        methods: {
          openBlog(blog){
            this.$bus.$emit('blog-modal.open', {blog});
          },
          getBlogUrl(blog){
            return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
          }
        },
        components:{
            BlogAvatar,
            fButton
        }
    }
</script>

<style lang="sass" scoped>
    .blogItem
        margin-bottom: .5em
        padding-bottom: .5em
        border-bottom: 1px solid #EEE

        h5 a
          color: #212529

</style>



// WEBPACK FOOTER //
// src/components/blogs/BlogListItemSmall.vue